import { render, staticRenderFns } from "./AffiliateDashboardTable.vue?vue&type=template&id=a1f60240&scoped=true&"
import script from "./AffiliateDashboardTable.vue?vue&type=script&lang=js&"
export * from "./AffiliateDashboardTable.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateDashboardTable.vue?vue&type=style&index=0&id=a1f60240&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f60240",
  null
  
)

export default component.exports